
export enum AiracType {
  AIRAC = "AIRAC",
  DOUBLE_AIRAC = "DOUBLE_AIRAC",
  NON_AIRAC = "NON_AIRAC",
}